import { render, staticRenderFns } from "./ManageModuleOrders.vue?vue&type=template&id=3d27776e&scoped=true&"
import script from "./ManageModuleOrders.vue?vue&type=script&lang=ts&"
export * from "./ManageModuleOrders.vue?vue&type=script&lang=ts&"
import style0 from "./ManageModuleOrders.vue?vue&type=style&index=0&id=3d27776e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d27776e",
  null
  
)

export default component.exports